import { render } from "./CommentContent.vue?vue&type=template&id=74dd12db&ts=true"
import script from "./CommentContent.vue?vue&type=script&lang=ts"
export * from "./CommentContent.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/mlp/mlp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__